<h1 mat-dialog-title>{{'Sign in' | translate}}</h1>
<mat-dialog-content class="mat-typography">
  <div class="example-container">
    <h2>{{competition.competitionName}} ({{competitionStart | date:'d.M'}} - {{competitionEnd | date:'d.M.yyyy'}})</h2>
    <form [formGroup]="raceSignInForm">
      <mat-form-field appearance="fill" style="min-width: 236px">
        <mat-label>{{'Crew number' | translate}}</mat-label>
        <mat-select formControlName="crew" [compareWith]="compareCrews" required>
          <mat-option *ngFor="let crew of crews"
                      [value]="crew"
                      (click)="selectDriverAndNavigatorAccordingToCrew(crew)">
            {{crew.number}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="this.raceSignInForm.get('crew').invalid">{{getErrorMessage(this.raceSignInForm.get('crew')) | translate}}</mat-error>
      </mat-form-field>
      <p>
        <mat-form-field appearance="fill" *ngIf="raceSignInForm.get('crew').valid" style="min-width: 236px">
          <mat-label>{{'Driver' | translate}}</mat-label>
          <mat-select formControlName="driver" [compareWith]="compareCompetitors" required>
            <mat-option value=""> {{'Select driver' | translate}} </mat-option>
            <mat-option *ngFor="let competitor of drivers"
                        [value]="competitor">
              {{competitor.firstName + ' ' + competitor.lastName}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="this.raceSignInForm.get('driver').invalid">{{getErrorMessage(this.raceSignInForm.get('driver')) | translate}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" *ngIf="raceSignInForm.get('crew').valid" style="min-width: 236px">
          <mat-label>{{'Navigator' | translate}}</mat-label>
          <mat-select formControlName="navigator" [compareWith]="compareCompetitors" required>
            <mat-option value=""> {{'Select navigator' | translate}} </mat-option>
            <mat-option *ngFor="let competitor of navigators"
                        [value]="competitor">
              {{competitor.firstName + ' ' + competitor.lastName}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="this.raceSignInForm.get('navigator').invalid">{{getErrorMessage(this.raceSignInForm.get('navigator')) | translate}}</mat-error>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="fill" style="max-width: 236px">
          <mat-label>{{'Accommodation' | translate}}</mat-label>
          <mat-date-range-input [rangePicker]="picker" required>
            <input matStartDate placeholder="Start date" formControlName="accommodationFrom" required>
            <input matEndDate placeholder="End date" formControlName="accommodationTo" required>
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
          <mat-error *ngIf="this.raceSignInForm.get('accommodationFrom').invalid || this.raceSignInForm.get('accommodationTo').invalid">{{getErrorMessageRangeDatePicker() | translate}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" style="min-width: 236px">
          <mat-label>{{'Note for organizer' | translate}}</mat-label>
          <textarea matInput
                    formControlName="noteCompetitor"
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="10"></textarea>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="fill" style="margin-top: 2%">
          <mat-label>{{'Additional competitor' | translate}}</mat-label>
          <mat-select formControlName="additionalCompetitor" [compareWith]="compareCompetitors">
            <mat-option value=""></mat-option>
            <mat-option *ngFor="let competitor of additionalCompetitors"
                        [value]="competitor">
              {{competitor.firstName + ' ' + competitor.lastName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-button color="primary"
                style="margin-left: 8px;"
                [disabled]="additionalCompetitorFieldIsEmpty()"
                (click)="processAvailableCompetitors()">
          {{'Add competitor' | translate}}
        </button>
        <mat-list role="list">
          <mat-list-item role="listitem"
                         *ngFor="let competitor of addedCompetitors">
            {{competitor.firstName + ' ' + competitor.lastName}}
            <button mat-icon-button
                    (click)="deleteAdditionalCompetitor(competitor)">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-list-item>
        </mat-list>
      </p>
    </form>
  </div>
</mat-dialog-content>
<mat-error *ngIf="alreadyInCompetition">{{errorMessage | translate}}</mat-error>
<mat-error *ngIf="notRegisteredInSeason">{{'This crew is not registered in the season' | translate}}</mat-error>
<mat-error *ngIf="serverIsDown">{{'Server problem, contact an administrator' | translate}}</mat-error>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{'Cancel' | translate}}</button>
  <button mat-button (click)="signToCompetition()" [disabled]="raceSignInForm.invalid">{{'Sign in' | translate}}</button>
</mat-dialog-actions>
